import React from "react";

const Footer = () => {
    return (
        <footer>

        <div className="level">
        <p>Adres: Gen. Jarosława Dąbrowskiego 25a 65-021</p>
        <p>E-mail: sekretariat@tiefbau.pl</p>
        <p>Numer telefonu: 537 053 266</p>
        <p><a 
        href="/polityka.pdf"
        target="_blank"
        rel="noopener noreferrer"

        >Polityka prywatności</a></p>


           

        </div>
        <div className="level">
            <p className="author">{`{ createdBy: butterSite }`}</p>
        </div>
    </footer>
    )
}


export default Footer